'use strict'

export const REQUEST_LIST_VEHICLES = 'REQUEST_LIST_VEHICLES'
export const REQUEST_LIST_VEHICLES_SUCCESS = 'REQUEST_LIST_VEHICLES_SUCCESS'
export const REQUEST_LIST_VEHICLES_ERROR = 'REQUEST_LIST_VEHICLES_ERROR'

export const REQUEST_CREATE_VEHICLE = 'REQUEST_CREATE_VEHICLE'
export const REQUEST_CREATE_VEHICLE_SUCCESS = 'REQUEST_CREATE_VEHICLE_SUCCESS'
export const REQUEST_CREATE_VEHICLE_ERROR = 'REQUEST_CREATE_VEHICLE_ERROR'

export const REQUEST_UPDATE_VEHICLE = 'REQUEST_UPDATE_VEHICLE'
export const REQUEST_UPDATE_VEHICLE_SUCCESS = 'REQUEST_UPDATE_VEHICLE_SUCCESS'
export const REQUEST_UPDATE_VEHICLE_ERROR = 'REQUEST_UPDATE_VEHICLE_ERROR'

export const REQUEST_DELETE_VEHICLE = 'REQUEST_DELETE_VEHICLE'
export const REQUEST_DELETE_VEHICLE_SUCCESS = 'REQUEST_DELETE_VEHICLE_SUCCESS'
export const REQUEST_DELETE_VEHICLE_ERROR = 'REQUEST_DELETE_VEHICLE_ERROR'

export const REQUEST_GET_VEHICLE = 'REQUEST_GET_VEHICLE'
export const REQUEST_GET_VEHICLE_SUCCESS = 'REQUEST_GET_VEHICLE_SUCCESS'
export const REQUEST_GET_VEHICLE_ERROR = 'REQUEST_GET_VEHICLE_ERROR'
